import { render } from "./NotificationTitleAndViewLiveResponses.vue?vue&type=template&id=2348e8f9&scoped=true&ts=true"
import script from "./NotificationTitleAndViewLiveResponses.vue?vue&type=script&lang=ts"
export * from "./NotificationTitleAndViewLiveResponses.vue?vue&type=script&lang=ts"

import "./NotificationTitleAndViewLiveResponses.vue?vue&type=style&index=0&id=2348e8f9&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2348e8f9"]])

export default __exports__